import { environment } from '../../environments/environment';

export const api = environment.api;

export interface ApiResponse<T> {
  data: T;
  errors?: Record<string, string[]>;
}

export type FormType = 'list' | 'full' | 'inform' | 'inline' | 'updatable';
export type FieldStatus = 'active' | 'readonly' | 'hidden';
export type LayoutView = Exclude<FormType, 'list'>;
export interface FieldLayout { column: number; width: number; position: number; }
export type FieldLayoutPatch = Partial<Record<LayoutView, Partial<FieldLayout>>>;

export interface FieldConfiguration {
  control?: 'dropdown' | 'checkbox';
  checkbox_require_yes?: boolean;
  label: string;
  status: FieldStatus;
  form_types: FormType[];
  form_appearance?: FieldLayoutPatch;
}

export interface EntityField {
  id: number;
  entity: string;
  name: string;
  label: string | null;
  type: string;
  status: string;
  base_entity: string | null;
  form_types: FormType[];
  form_appearance: Record<string, unknown> | null;
  props: Record<string, unknown> | null;
}

export interface CurrentUser {
  id: number;
  email?: string;
  name?: string;
}

export type PermissionMap = Record<string, string[]>;

export interface SystemSettings {
  default_table_column_width: number;
  help_url?: string | null;
}

export interface SidebarMenuItem {
  id: number;
  name: string;
  label: string;
  order: number | null;
  role_ids: number[];
}

export interface AdminRole {
  id: number;
  name: string;
}

export interface AdminUserAccess {
  id: number;
  name: string;
  email: string;
  agent_payments_enabled: boolean;
}

export interface AccessUser {
  id: number;
  name: string;
  email: string;
  role_ids: number[];
  group_ids: number[];
}

export interface AccessRole {
  id: number;
  name: string;
  users_count: number;
  permissions_count: number;
}

export interface AccessGroup {
  id: number;
  name: string;
}

export interface AccessPermission {
  id: number;
  name: string;
}

export type AccessScope = 'all' | 'own' | 'group';

export interface AccessPermissionAssignment {
  permission_id: number;
  scope: AccessScope;
  group_id: number | null;
}

export interface AccessOverview {
  users: AccessUser[];
  roles: AccessRole[];
  groups: AccessGroup[];
}

export interface RolePermissions {
  role: Pick<AccessRole, 'id' | 'name'>;
  permissions: AccessPermission[];
  assignments: AccessPermissionAssignment[];
}
